const translations = {
  es: {
    login: {
      title: "Bienvenido de vuelta",
      sub: "Accedé a tu plataforma de formación",
      email: "Email",
      password: "Contraseña",
      btn: "Entrar a la plataforma",
      or: "¿nuevo por acá?",
      register: "Crear cuenta gratis",
      stat: "afiliados entrenados",
      b1: "Cursos en video",
      b2: "Soporte 24/7",
      b3: "Acceso de por vida",
      b4: "Certificado",
    },
    library: {
      welcome: "Hola",
      access: "Tu acceso",
      progress: "Progreso general",
      lessons: "lecciones",
      enter: "Entrar al curso",
      soon: "Próximamente",
      logout: "Cerrar sesión",
    },
    course: {
      back: "Biblioteca",
      prev: "Anterior",
      next: "Siguiente",
      complete: "Marcar como completada",
      of: "de",
    },
  },
  en: {
    login: {
      title: "Welcome back",
      sub: "Access your affiliate training platform",
      email: "Email",
      password: "Password",
      btn: "Sign in to platform",
      or: "new here?",
      register: "Create free account",
      stat: "trained affiliates",
      b1: "Video courses",
      b2: "24/7 Support",
      b3: "Lifetime access",
      b4: "Certificate",
    },
    library: {
      welcome: "Hello",
      access: "Your access",
      progress: "Overall progress",
      lessons: "lessons",
      enter: "Enter course",
      soon: "Coming soon",
      logout: "Sign out",
    },
    course: {
      back: "Library",
      prev: "Previous",
      next: "Next",
      complete: "Mark as complete",
      of: "of",
    },
  },
};

export const detectLang = () => {
  const saved = localStorage.getItem("lang");
  if (saved) return saved;
  const browser = navigator.language || navigator.userLanguage;
  return browser.startsWith("en") ? "en" : "es";
};

export const t = (lang, section, key) => {
  return translations[lang]?.[section]?.[key] || key;
};

export default translations;
